import { useState } from 'react'
import { CardViewMode, CardItem } from '../types'

const INITIAL_GRAPH_ITEMS = 12
const INITIAL_LIST_ITEMS = 1

export const useCardExpansion = (items: CardItem[], viewMode: CardViewMode) => {
    const [isExpanded, setIsExpanded] = useState(false)
    const [isGraphViewExpanded, setIsGraphViewExpanded] = useState(false)

    const onToggleExpand = () => setIsExpanded(!isExpanded)
    const onScrollExpand = () => {
        if (viewMode === 'graphs' && !isGraphViewExpanded) {
            setIsGraphViewExpanded(true)
        }
    }

    const isListView = viewMode === 'list'
    const isGraphView = viewMode === 'graphs'

    const totalItems = items.length
    const canExpandInList = isListView && totalItems > INITIAL_LIST_ITEMS
    const canExpandInGraph = isGraphView && totalItems > INITIAL_GRAPH_ITEMS

    let itemsToShow = items
    if (canExpandInList && !isExpanded) {
        itemsToShow = items.slice(0, INITIAL_LIST_ITEMS)
    } else if (canExpandInGraph && !isGraphViewExpanded) {
        itemsToShow = items.slice(0, INITIAL_GRAPH_ITEMS)
    }

    const visibleItemsCount = itemsToShow.length

    return {
        isExpanded,
        onToggleExpand,
        onScrollExpand,
        itemsToShow,
        totalItems,
        canExpand: canExpandInList,
        visibleItemsCount,
    }
}
